import { render, staticRenderFns } from "./NittoColorData.vue?vue&type=template&id=586416e2&scoped=true&"
import script from "./NittoColorData.vue?vue&type=script&lang=js&"
export * from "./NittoColorData.vue?vue&type=script&lang=js&"
import style0 from "./NittoColorData.vue?vue&type=style&index=0&id=586416e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586416e2",
  null
  
)

export default component.exports